module.exports = __webpack_public_path__ + "img/borrower_signup_hero_mobile.fe28c5dc.jpg";